import { IconPropsType } from '..';

export const ArrowRightToLine = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=default, statuses=default, arrows=collapse-right, toggleables=default, signs=default, menus=default, casino=default">
      <path
        id="Vector"
        d="M8.40504 6.45162L11.2467 9.30161H3.33337V10.8883H11.2467L8.39671 13.7383L9.52337 14.8566L14.285 10.0949L9.52337 5.33328L8.40504 6.45162ZM15.08 5.33328V14.8566H16.6667V5.33328H15.08Z"
      />
    </g>
  </svg>
);
